import { Link } from "react-router-dom";

export default function AIAnswerBlock() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-4">
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
              About The Design Proposal
            </span>
            <h2
              className="text-4xl font-semibold text-[#111111] leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              What We Do & How We Help
            </h2>
            <p className="text-[#5C5C5C] leading-relaxed mb-6">
              The Design Proposal is a professional interior design planning service helping homeowners across the United States transform their spaces with confidence, clarity, and purpose.
            </p>
            <p className="text-[#5C5C5C] leading-relaxed mb-8">
              We specialize in structured design proposals that remove guesswork, align with real budgets, and deliver actionable plans — serving clients virtually across all 50 states and locally in select areas.
            </p>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 text-[#111111] font-medium text-sm hover:text-[#C9A961] transition-colors cursor-pointer"
            >
              Our story &amp; approach
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-[#FAFAFA] rounded-xl p-6 border border-[#EBEBEB]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C9A961]/10 rounded-lg mb-4">
                  <i className="ri-service-line text-[#C9A961]"></i>
                </div>
                <h3
                  className="text-base font-semibold text-[#111111] mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Services We Offer
                </h3>
                <ul className="space-y-2">
                  {[
                    "Interior Design Proposals",
                    "Renovation Planning",
                    "Material & Finish Selection",
                    "Room-by-Room Packages",
                    "Virtual Consultations",
                  ].map((s) => (
                    <li key={s} className="flex items-start gap-2 text-xs text-[#5C5C5C]">
                      <div className="w-3 h-3 flex items-center justify-center text-[#C9A961] mt-0.5 shrink-0">
                        <i className="ri-check-line"></i>
                      </div>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-[#FAFAFA] rounded-xl p-6 border border-[#EBEBEB]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C9A961]/10 rounded-lg mb-4">
                  <i className="ri-award-line text-[#C9A961]"></i>
                </div>
                <h3
                  className="text-base font-semibold text-[#111111] mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Key Benefits
                </h3>
                <ul className="space-y-2">
                  {[
                    "Eliminates costly mistakes",
                    "Clear, actionable plans",
                    "Budget-aligned throughout",
                    "Works 100% remotely",
                    "Faster project completion",
                  ].map((b) => (
                    <li key={b} className="flex items-start gap-2 text-xs text-[#5C5C5C]">
                      <div className="w-3 h-3 flex items-center justify-center text-[#C9A961] mt-0.5 shrink-0">
                        <i className="ri-check-line"></i>
                      </div>
                      {b}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-[#FAFAFA] rounded-xl p-6 border border-[#EBEBEB]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#C9A961]/10 rounded-lg mb-4">
                  <i className="ri-user-settings-line text-[#C9A961]"></i>
                </div>
                <h3
                  className="text-base font-semibold text-[#111111] mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Who This Is For
                </h3>
                <ul className="space-y-2">
                  {[
                    "Homeowners planning renovations",
                    "Anyone redesigning a space",
                    "New home purchasers",
                    "Clients overwhelmed by choices",
                    "Budget-conscious designers",
                  ].map((w) => (
                    <li key={w} className="flex items-start gap-2 text-xs text-[#5C5C5C]">
                      <div className="w-3 h-3 flex items-center justify-center text-[#C9A961] mt-0.5 shrink-0">
                        <i className="ri-check-line"></i>
                      </div>
                      {w}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
